<script lang="ts">
  export let url = "";
  export let maxDimension = NaN;

  let showError = false;

  let className = "mx-auto w-full sm:w-4/6";
  const noMemeMessage = "Couldn't load meme :(";

  // Reset error when URL changes
  $: {
    url;
    showError = false;
  }
</script>

{#if url && !showError}
  <img
    class={className + " md:w-1/2" + (isNaN(maxDimension) ? " max-w-md" : "")}
    style={maxDimension
      ? `max-width: ${maxDimension}px; max-height: ${maxDimension}px;`
      : ""}
    src={url}
    alt="Meme"
    on:error={() => {
      showError = true;
      console.log("Detected error");
    }}
  />
{:else}
  <p class={className + " text-center"}>
    <slot>{noMemeMessage}</slot>
  </p>
{/if}
